import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "./pages/AuthCallback";
import Resources from "./pages/Resources";
import Pay from "./pages/Pay";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Book from "./pages/Book";
import Speaking from "./pages/Speaking";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
};

const NotFound = () => (
  <section className="bg-cream text-ink py-28"><div className="max-w-6xl mx-auto px-6"><h1>Page not found</h1><a href="/" className="mt-6 inline-flex text-teal underline">Go to the home page</a></div></section>
);

// Detect Google sign-in return during render (before any protected route runs)
const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/pay/:token" element={<Pay />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <div className="min-h-screen flex flex-col bg-cream text-ink">
        <Nav />
        <main id="main" tabIndex={-1} className="flex-1 focus:outline-none">
          <AppRoutes />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
